import { DateTime } from 'luxon'
import { computed, Ref, ref, watch } from 'vue'
import EventService from '@/services/EventService'
import { DataTableFilter } from '@/types/DataTable'
import TicketType from '@/types/TicketType'

interface TicketTypeFilterPayload {
  event: Ref<string | null>
  label: string
  field: string
}

export function useTicketTypeFilter({ event, label, field }: TicketTypeFilterPayload): DataTableFilter<string> {
  const model: Ref<string | null> = ref(null)

  const loading = ref(false)

  const expires = ref<DateTime>()

  const items: Ref<TicketType[]> = ref([])

  const ready = Promise.withResolvers<boolean>()

  const load = async () => {
    if (event.value === null) return

    loading.value = true

    const service = new EventService()

    const response = await service.types(event.value)

    items.value = response.data

    expires.value = DateTime.now().plus({ minutes: 5 })

    ready.resolve(true)
    loading.value = false
  }

  watch(event, () => load(), { immediate: true })

  return {
    model,
    value: computed(() => model.value),
    items: computed(
      () => {
        if (expires.value !== undefined && DateTime.now() > expires.value) {
          load()
        }

        const _items: { title: string, value: string }[] = []

        items.value.forEach((i) => {
          if (!_items.find(ii => ii.title === i.name)) {
            _items.push({ title: i.name, value: i.id })
          }
        })

        return _items
      },
    ),
    label,
    field,
    type: 'autocomplete',
    loading,
    required: false,
    ready: ready.promise,
  }
}
